import React from 'react';
import { FiSearch } from 'react-icons/fi';

import { Container, SearchBox, SearchInput, Select, Count } from './styles';

export interface SearchFieldFilter {
  value: string;
  label: string;
  options: { value: string; label: string }[];
  onChange: (value: string) => void;
}

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Rótulo acessível do campo de busca. */
  label: string;
  /** Filtro opcional ao lado da busca (ex.: status). */
  filter?: SearchFieldFilter;
  /** Texto de contagem à direita (ex.: "12 de 40 usuários"). */
  count?: string;
}

/**
 * Busca (e filtro opcional) de listas do admin. Atua no cliente sobre o que
 * já foi carregado — o backend não oferece busca nem filtro.
 */
const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder,
  label,
  filter,
  count,
}) => (
  <Container>
    <SearchBox>
      <FiSearch size={16} aria-hidden />
      <SearchInput
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={label}
        onChange={(e) => onChange(e.target.value)}
      />
    </SearchBox>
    {filter && (
      <Select
        value={filter.value}
        aria-label={filter.label}
        onChange={(e) => filter.onChange(e.target.value)}
      >
        {filter.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    )}
    {count && <Count aria-live="polite">{count}</Count>}
  </Container>
);

export default SearchField;
